<template>
  <div class="row" style="padding-top:20px;">
    <div class="col m3" v-for="item in options">
      <p>
        <label>
          <input type="checkbox" @change="checkBoxChange($event,item)"/>
          <span>{{ item.name }}</span>
        </label>
      </p>
    </div>
   
  </div>
</template>
<script>
export default {
  props: ["options","data"],
  methods: {
      checkBoxChange(e,item)
      {
          if (e.target.checked)
          {
            //   this.data.push(item.id);
            //  this.$emit("pushValue",item.id,this.data);
          }
          
      }
  }
};
</script>
<style>
</style>